// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderV2Gender } from './pharmacyCardFinderV2Gender.js';
import type { PharmacyCardFinderV2PatientAddress } from './pharmacyCardFinderV2PatientAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyCardFinderV2PatientRequest {
    'address': PharmacyCardFinderV2PatientAddress | null;
    'dateOfBirth': Moment;
    'firstName': string;
    'gender': PharmacyCardFinderV2Gender;
    'lastName': string;
    'phone'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyCardFinderV2PatientRequest>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PharmacyCardFinderV2PatientAddress"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "PharmacyCardFinderV2Gender"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyCardFinderV2PatientRequest.attributeTypeMap;
    }
}
